"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpcodeDerivationTemplate = getOpcodeDerivationTemplate;
exports.getOpcodeDerivationInitTemplate = getOpcodeDerivationInitTemplate;
const VMConstants_1 = require("../../../constants/VMConstants");
function getOpcodeDerivationTemplate() {
    return `
            // ===== Opcode Derivation Functions =====
            // These derive the opcode mapping from a seed at runtime

            // Derivation constants (must match compile-time exactly)
            let _D_MULT1 = 0x85EBCA6B;
            let _D_MULT2 = 0xC2B2AE35;
            let _D_SHIFT1 = 0x10;
            let _D_SHIFT2 = 0x0D;
            let _D_SHIFT3 = 0x10;
            let _D_PHI = 0x9E3779B9; // Golden ratio derivative
            let _D_OPCODE_COUNT = ${VMConstants_1.VM_OPCODE_COUNT}; // Must cover all VMOpCode values (including macro-ops 250-261)

            // Mix bits of a 32-bit integer (MurmurHash3 finalizer variant)
            function _mixBits(h) {
                h = h >>> 0;
                h ^= h >>> _D_SHIFT1;
                h = Math.imul(h, _D_MULT1) >>> 0;
                h ^= h >>> _D_SHIFT2;
                h = Math.imul(h, _D_MULT2) >>> 0;
                h ^= h >>> _D_SHIFT3;
                return h >>> 0;
            }

            // Derive a pseudo-random value from seed and index
            function _deriveValue(seed, index) {
                let combined = (seed ^ (index * _D_PHI)) >>> 0;
                combined = (combined ^ (combined >>> 11)) >>> 0;
                combined = Math.imul(combined, 0x1B873593) >>> 0;
                combined = (combined ^ (combined >>> 15)) >>> 0;
                return _mixBits(combined);
            }

            // Generate opcode mapping table from seed using Fisher-Yates shuffle
            function _deriveOpcodeTable(seed, instrCount, constCount) {
                // Layer 1: Mix seed with function metadata
                let mixedSeed = seed ^ ((instrCount * _D_PHI) >>> 0);
                mixedSeed = (mixedSeed ^ ((constCount * 0x27D4EB2D) >>> 0)) >>> 0;
                mixedSeed = _mixBits(mixedSeed);

                // Layer 2: Create initial array [0, 1, 2, ..., 127]
                let arr = [];
                for (let i = 0; i < _D_OPCODE_COUNT; i++) {
                    arr[i] = i;
                }

                // Layer 3: Fisher-Yates shuffle with derived random values
                for (let i = _D_OPCODE_COUNT - 1; i > 0; i--) {
                    let randVal = _deriveValue(mixedSeed, i);
                    let j = randVal % (i + 1);
                    let tmp = arr[i];
                    arr[i] = arr[j];
                    arr[j] = tmp;
                }

                // Convert to lookup object: logical -> randomized
                let opMap = {};
                for (let i = 0; i < _D_OPCODE_COUNT; i++) {
                    opMap[i] = arr[i];
                }

                return opMap;
            }

            // Cache for derived opcode tables (keyed by seed + metadata)
            let _derivedTables = {};

            // Get or create opcode table from seed
            function _getOpcodeTable(seed, instrCount, constCount) {
                let cacheKey = seed + '_' + instrCount + '_' + constCount;
                if (!_derivedTables[cacheKey]) {
                    _derivedTables[cacheKey] = _deriveOpcodeTable(seed, instrCount, constCount);
                }
                return _derivedTables[cacheKey];
            }
`;
}
function getOpcodeDerivationInitTemplate() {
    return `
                // Runtime opcode derivation: derive opcode table from seed if present
                if (bc.os !== undefined) {
                    let instrCount = instructions.length >> 1;
                    let constCount = constants ? constants.length : 0;
                    opMap = _getOpcodeTable(bc.os, instrCount, constCount);
                }
`;
}
